/**
 * Magic property name BFF uses for `ExperimentalReadPlanBFFV1`’s `data` → `blocks` → `by_category_with_position` object
 * to track ‘pre-planning’ blocks (i.e. blocks that don’t have a `start_at` or `category_id`). All other property names
 * in `by_category_with_position` are `Loupe.Schema.Category` / `loupe.categories` `id`s.
 */
export const prePlanningBlockKey = 'preplanning_blocks'
